import { Alert, Box, Button, Container, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ModalCalcSimplifiedCoverage from '~/modals/CalcSimplifiedCoverage';
import { useGetStepPlans } from '~/modals/CalcSimplifiedCoverage/hooks/use-get-plans';
import { isPromotionUnavailable } from '~/utils/promotionUtils';
import ErrorPage from '../Error';

export default function BasicModal() {
  const { data, loading, error } = useGetStepPlans();
  const [searchParams] = useSearchParams();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Verificar se deve abrir o modal baseado no parâmetro de URL ou automaticamente
  useEffect(() => {
    if (!data || loading) return;

    const modalParam = searchParams.get('modal');
    const promotionUnavailable = isPromotionUnavailable(data);

    // Abrir modal automaticamente se:
    // 1. Há parâmetro modal=true na URL, OU
    // 2. É um fluxo normal (sem promoção), OU
    // 3. É um fluxo de promoção disponível
    const shouldAutoOpen = modalParam === 'true' || !promotionUnavailable;

    if (shouldAutoOpen) {
      setIsModalOpen(true);
    }
  }, [searchParams, data, loading]);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // Verificar se a promoção não está disponível
  const promotionUnavailable = isPromotionUnavailable(data);

  if (loading) {
    return <div> Loading </div>;
  }

  if (error) {
    return <ErrorPage statusCode={error.statusCode} message={error.message} />;
  }

  return (
    <Container maxWidth="sm">
      {!isModalOpen && !promotionUnavailable && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '50vh',
            textAlign: 'center',
            gap: 2
          }}
        >
          <Typography variant="h5" component="h1" gutterBottom>
            Cálculo de Cobertura
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Calcule sua cobertura de forma rápida e simples
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleOpenModal}
            sx={{
              minWidth: 200,
              padding: '12px 24px',
              fontSize: '1rem'
            }}
          >
            Iniciar Cálculo
          </Button>
        </Box>
      )}

      {/* Exibir mensagem quando a promoção não estiver disponível */}
      {promotionUnavailable && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '50vh',
            textAlign: 'center',
            gap: 2
          }}
        >
          <Alert severity="warning" sx={{ width: '100%', maxWidth: '500px' }}>
            <Typography variant="h6" component="div" gutterBottom>
              Promoção Indisponível
            </Typography>
            <Typography variant="body1">
              Esta promoção não está mais disponível. Tente novamente mais tarde ou entre em contato conosco para mais
              informações.
            </Typography>
          </Alert>
        </Box>
      )}

      {/* Renderizar modal apenas se a promoção estiver disponível */}
      {isModalOpen && !promotionUnavailable && (
        <>
          {data?.club ? (
            <ModalCalcSimplifiedCoverage
              steps={data?.steps}
              club={data.club}
              distributor={data?.distributor ?? undefined}
              sellerInfo={typeof data?.seller === 'object' && data.seller !== null ? data.seller : undefined}
              isOpen={isModalOpen}
              onClose={handleCloseModal}
            />
          ) : (
            <ModalCalcSimplifiedCoverage
              steps={data?.steps}
              distributor={data?.distributor ?? undefined}
              sellerInfo={typeof data?.seller === 'object' && data.seller !== null ? data.seller : undefined}
              isOpen={isModalOpen}
              onClose={handleCloseModal}
            />
          )}
        </>
      )}
    </Container>
  );
}
